export const PLANT_CONFIGURATION_CODE = 'PSHYDPROPLACON';
